"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerResources = void 0;
var vue_1 = require("vue");
var CardName_1 = require("../../CardName");
var PlayerResource_1 = require("./PlayerResource");
var Resources_1 = require("../../Resources");
exports.PlayerResources = vue_1.default.component('player-resources', {
    props: {
        player: {
            type: Object,
        },
    },
    data: function () {
        return {
            resources: Resources_1.Resources,
        };
    },
    methods: {
        canUseHeatAsMegaCredits: function () {
            var _a;
            return ((_a = this.player.corporationCard) === null || _a === void 0 ? void 0 : _a.name) === CardName_1.CardName.HELION;
        },
    },
    components: {
        'player-resource': PlayerResource_1.PlayerResource,
    },
    template: "\n        <div class=\"resource_items_cont\">\n            <player-resource :type=\"resources.MEGACREDITS\" :count=\"player.megaCredits\" :production=\"player.megaCreditProduction\"></player-resource>\n            <player-resource :type=\"resources.STEEL\" :count=\"player.steel\" :production=\"player.steelProduction\" :steelValue=\"player.steelValue\"></player-resource>\n            <player-resource :type=\"resources.TITANIUM\" :count=\"player.titanium\" :production=\"player.titaniumProduction\" :titaniumValue=\"player.titaniumValue\"></player-resource>\n            <player-resource :type=\"resources.PLANTS\" :count=\"player.plants\" :production=\"player.plantProduction\" :plantsAreProtected=\"player.plantsAreProtected\"></player-resource>\n            <player-resource :type=\"resources.ENERGY\" :count=\"player.energy\" :production=\"player.energyProduction\"></player-resource>\n            <player-resource :type=\"resources.HEAT\" :count=\"player.heat\" :production=\"player.heatProduction\" :canUseHeatAsMegaCredits=\"canUseHeatAsMegaCredits()\"></player-resource>\n        </div>\n    ",
});
//# sourceMappingURL=PlayerResources.js.map